module.exports = __webpack_public_path__ + "media/Tarjeta 146b.c3ecb939.mp4";